import type { Observability, ObservabilityUser } from "./index";
import { isLocal } from "@/lib/env";

/**
 * Console-only Observability implementation.
 *
 * In dev, prints captured events + user changes for debugging visibility.
 * In staging/prod, only `captureError` is logged — events are silenced to
 * avoid noisy DevTools (until a real backend like Sentry is wired in).
 */
export const consoleObservability: Observability = {
  captureError(error, context) {
    // Always log errors; this is the one signal we never want to lose.
    console.error("[obs] error", error, context ?? {});
  },
  captureEvent(name, props) {
    if (!isLocal) return;
    console.info(`[obs] event ${name}`, props ?? {});
  },
  setUser(user: ObservabilityUser | null) {
    if (!isLocal) return;
    console.info("[obs] setUser", user);
  },
};
